import React, { useState, useEffect } from 'react';
import { ProyectoForm } from './ProyectoForm';
import { History } from '../../../../../../_metronic/helpers/components/History';
import { Toggle } from '../../../../../../_metronic/partials/layout/explore/Toggle';
import {
  useGetHistory,
  useInsertMessageProject,
} from '../../hooks/ProyectosHook';

type Props = {
  proyectoId: number;
  oportunidadId: number;
};

const View: React.FC<Props> = ({ proyectoId, oportunidadId }) => {
  const [reloadGrid, setReloadGrid] = useState<number>(Math.random() * 40);
  const [showTimerHistory, setShowTimerHistory] = useState<boolean>(true);
  const [showHistory, setShowHistory] = useState<boolean>(true);
  const [search, setSearch] = useState<string>('');
  const { data } = useGetHistory(reloadGrid, search, proyectoId.toString());
  const { insertData, loadingInsert } = useInsertMessageProject();

  const onRefreshData = () => {
    setReloadGrid(Math.random() * 40);
  };

  const historyStyle: React.CSSProperties = {
    transform: showHistory ? 'none' : 'translateX(110%)',
    transition: 'transform 0.4s ease-in-out',
  };

  const saveMessage = (message: string) => {
    insertData(message, proyectoId);
  };

  useEffect(() => {
    if (loadingInsert) {
      setReloadGrid(Math.random() * 40);
    }
  }, [loadingInsert]);

  useEffect(() => {
    if (!showHistory) {
      setTimeout(() => {
        setShowTimerHistory(false);
      }, 400);
    }
  }, [showHistory]);

  useEffect(() => {
    const historyMode = localStorage.getItem('isOpenHistory') || '';
    setShowHistory(historyMode ? JSON.parse(historyMode) : true);
    setShowTimerHistory(historyMode ? JSON.parse(historyMode) : true);
  }, []);

  return (
    <>
      <div className="d-flex flex-column flex-xl-row">
        <div className="flex-lg-row-fluid transform">
          <ProyectoForm
            proyectoId={proyectoId}
            onRefreshHistory={onRefreshData}
            oportunidadId={oportunidadId}
            // onDisabledHistory={onDisabledHistory}
          />
        </div>
        <div style={historyStyle}>
          {Number(proyectoId) > 0 && showTimerHistory && (
            <>
              <div className="flex-column flex-lg-row-auto w-100 w-xl-400px ms-lg-10">
                <History
                  data={data}
                  onSaveMessage={saveMessage}
                  disabled={false}
                  onShow={() => {
                    setShowHistory(!showHistory);
                    const boolean = !showHistory;
                    localStorage.setItem('isOpenHistory', boolean.toString());
                  }}
                />
              </div>
            </>
          )}
        </div>
        {!showHistory && Number(proyectoId) > 0 && (
          <Toggle
            onShow={() => {
              setShowHistory(!showHistory);
              setShowTimerHistory(true);
              const boolean = !showHistory;
              localStorage.setItem('isOpenHistory', boolean.toString());
            }}
          />
        )}
      </div>
    </>
  );
};

export { View };
